/* eslint-disable no-useless-escape */

/**
 * It validates the email with a regular expression.
 *
 * @param email - The email address to validate.
 */
export const isEmail = (email: string): boolean => {
  const pattern =
    // eslint-disable-next-line regexp/no-unused-capturing-group, regexp/use-ignore-case, regexp/strict
    /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/

  return pattern.test(email)
}
